// Phones in portrait and landscape share the compact console layout.
export const TRX_COMPACT_QUERY = '(max-width: 767px), (max-width: 1023px) and (max-height: 500px)';

export const trxResearchSections = ['comparison', 'results', 'diagnostics', 'shadow'] as const;
export type TrxWorkspaceSection = 'account' | (typeof trxResearchSections)[number];

// Keep old bookmarks useful without mounting generic trading/account screens.
export function trxLegacyDestination(path: string) {
  if (
    [
      '/trade',
      '/dashboard',
      '/balance',
      '/open_trades',
      '/trade_history',
      '/pairlist',
      '/graph',
      '/logs',
    ].includes(path)
  )
    return { path: '/trx', query: { section: 'account' } };
  if (['/backtest', '/download_data', '/pairlist_config'].includes(path))
    return { path: '/trx', query: { section: 'comparison' } };
  if (['/recursive_analysis', '/lookahead_analysis'].includes(path))
    return { path: '/trx', query: { section: 'diagnostics' } };
}

export function trxWorkspaceSection(value: unknown): TrxWorkspaceSection {
  return typeof value === 'string' && trxResearchSections.some((section) => section === value)
    ? (value as TrxWorkspaceSection)
    : 'account';
}

export function trxSavedId(value: unknown): string | undefined {
  return typeof value === 'string' && /^[\w-]{1,128}$/.test(value) ? value : undefined;
}
